import { faRegistered, faShieldHalved, faThumbTack } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "semantic-ui-react";

import { PIN_TYPES } from "models";

type PinTypeIconProps = {
  pinTypeId: number;
  isPrint?: boolean;
  onClick?: () => void;
};

export const PIN_TYPE_ICON_MAP: Record<PIN_TYPES, { icon: string }> = {
  [PIN_TYPES.Warranty]: { icon: "shield halved" },
  [PIN_TYPES.Recall]: { icon: "registered" },
  [PIN_TYPES.Remarks]: { icon: "thumb tack" }
};

export const PinTypeIcon = ({ pinTypeId, isPrint, onClick }: PinTypeIconProps) => {
  if (pinTypeId === PIN_TYPES.Warranty)
    return isPrint ? <FontAwesomeIcon icon={faShieldHalved} onClick={onClick} /> : <Icon className="shield halved" onClick={onClick} />;
  if (pinTypeId === PIN_TYPES.Recall) return isPrint ? <FontAwesomeIcon icon={faRegistered} onClick={onClick} /> : <Icon className="registered" onClick={onClick} />;
  if (pinTypeId === PIN_TYPES.Remarks) return isPrint ? <FontAwesomeIcon icon={faThumbTack} onClick={onClick} /> : <Icon className="thumb tack" onClick={onClick} />;
  return isPrint ? <FontAwesomeIcon icon={faThumbTack} onClick={onClick} /> : <Icon className="thumb tack" onClick={onClick} />;
};
